"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-console */
/* eslint-disable class-methods-use-this */
const axios_1 = __importDefault(require("axios"));
const BaseBuyProvider_1 = require("../BaseBuyProvider");
const simplex_png_1 = __importDefault(require("../../../../static/providers/simplex.png"));
const countries_1 = __importDefault(require("./countries"));
const cryptos_1 = __importDefault(require("./cryptos"));
const fiats_1 = __importDefault(require("./fiats"));
const paymentOptions_1 = __importDefault(require("./paymentOptions"));
const apiKeys_1 = require("../../data/apiKeys");
const constants_1 = require("./constants");
const fiatRates_1 = require("../../helpers/fiatRates");
const SIMPLEX_BASE_API = process.env.DEPLOY_ENV === "production"
    ? constants_1.SIMPLEX_API_BASE_PROD
    : constants_1.SIMPLEX_API_BASE_SANDBOX;
const SIMPLEX_API_KEY = process.env.DEPLOY_ENV === "production"
    ? apiKeys_1.SIMPLEX_API_KEY_PROD
    : apiKeys_1.SIMPLEX_API_KEY_TEST;
class SimplexProvider {
    constructor() {
        this.id = "simplex";
        this.name = "Simplex";
        this.logo = simplex_png_1.default;
        this.addressPassthrough = true;
        this.defaultFiatCurrency = "USD";
        this.fiats = [];
        this.cryptos = [];
    }
    fetchSupportedFiats() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const url = `${SIMPLEX_BASE_API}${constants_1.SIMPLEX_API_ENDPOINTS.FIAT_CURRENCIES_V2}`;
                const { data } = yield axios_1.default.get(url, {
                    params: { public_key: SIMPLEX_API_KEY },
                });
                this.fiats = data;
            }
            catch (error) {
                console.log("Error getting simplex fiat, using fallback", error);
                this.fiats = fiats_1.default;
            }
        });
    }
    fetchSupportedCryptos() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const url = `${SIMPLEX_BASE_API}${constants_1.SIMPLEX_API_ENDPOINTS.CRYPTO_CURRENCIES_V2}`;
                const res = yield axios_1.default.get(url, {
                    params: { public_key: SIMPLEX_API_KEY },
                });
                this.cryptos = res.data.map((i) => i.ticker_symbol.replace("-ERC20", ""));
                console.log(this.cryptos, res.data);
            }
            catch (error) {
                console.log("Error getting simplex fiat, using fallback", error);
                this.cryptos = cryptos_1.default.map((i) => i.ticker_symbol);
            }
        });
    }
    getSupportedCountries() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const url = `${SIMPLEX_BASE_API}${constants_1.SIMPLEX_API_ENDPOINTS.SUPPORTED_COUNTRIES_V2}`;
                const { data } = yield axios_1.default.get(url, {
                    params: {
                        public_key: SIMPLEX_API_KEY,
                    },
                });
                return data;
            }
            catch (error) {
                console.log("Error getting simplex countries, using fallback", error);
                return countries_1.default;
            }
        });
    }
    getAvailability(countryData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!countryData)
                return false;
            const countries = yield this.getSupportedCountries();
            // need to work out how to filter through us states too....
            return countries.includes(countryData.alpha2.toUpperCase());
        });
    }
    getSupportedCryptos() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.cryptos.length === 0) {
                yield this.fetchSupportedCryptos();
            }
            return this.cryptos;
        });
    }
    getSupportedFiat() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.fiats.length === 0) {
                yield this.fetchSupportedFiats();
            }
            return this.fiats.map((i) => i.ticker_symbol);
        });
    }
    getPaymentMethods() {
        return __awaiter(this, void 0, void 0, function* () {
            return paymentOptions_1.default;
        });
    }
    getBuyQuote(cryptoCode, fiatCode, fiatAmount, geoLocation) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const paymentOptions = yield this.getPaymentMethods();
                const isRequestedCurrency = (yield this.getSupportedFiat()).includes(fiatCode);
                const currencyCode = isRequestedCurrency
                    ? fiatCode.toUpperCase()
                    : this.defaultFiatCurrency;
                const convertedRate = isRequestedCurrency
                    ? fiatAmount
                    : Math.ceil(yield (0, fiatRates_1.convertFiatRate)(currencyCode, fiatCode, fiatAmount));
                const responseData = {
                    cryptoAmount: -1,
                    fiatAmount: convertedRate,
                    provider: this.id,
                    rate: -1,
                    isRequestedCurrency,
                    paymentOptions,
                    fiatCode: currencyCode,
                };
                return responseData;
            }
            catch (error) {
                console.log("Error getting simplex quote", error);
                return BaseBuyProvider_1.DEFAULT_ERROR;
            }
        });
    }
}
exports.default = SimplexProvider;
//# sourceMappingURL=Simplex.js.map